// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JG2dk","inner":"Footer_inner__1osfq"};